/* global axios */
import ApiClient from './ApiClient';

class PipelineAPI extends ApiClient {
  constructor() {
    super('pipelines', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(pipeline) {
    return axios.post(this.url, pipeline);
  }

  update(id, pipeline) {
    return axios.patch(`${this.url}/${id}`, pipeline);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  // Stages are nested under pipelines
  stages(pipelineId) {
    return axios.get(`${this.url}/${pipelineId}/stages`);
  }

  createStage(pipelineId, stage) {
    return axios.post(`${this.url}/${pipelineId}/stages`, stage);
  }

  updateStage(pipelineId, stageId, stage) {
    return axios.patch(`${this.url}/${pipelineId}/stages/${stageId}`, stage);
  }

  deleteStage(pipelineId, stageId) {
    return axios.delete(`${this.url}/${pipelineId}/stages/${stageId}`);
  }

  reorderStages(pipelineId, stageIds) {
    return axios.post(`${this.url}/${pipelineId}/stages/reorder`, {
      stage_ids: stageIds,
    });
  }
}

export default new PipelineAPI();
